import { Legacy, AreaSeed } from '@/infrastructure/network/Legacy/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IParamsProps } from '@/entities/Legacy/Options'

export class GetArea implements APIRequest<Legacy.Area.getAreaResponse> {
  response: Legacy.Area.getAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(areaId: string) {
    this.path = `/areas/${areaId}`
  }
}

export class GetAreas implements APIRequest<Legacy.Area.getAreasResponse> {
  response: Legacy.Area.getAreasResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params: IParamsProps
  constructor(params: IParamsProps) {
    this.params = params
    this.path = '/areas'
  }
}

export class PostArea implements APIRequest<Legacy.Area.postAreaResponse> {
  response: Legacy.Area.postAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Legacy.Area.postAreaRequest
  constructor(params: AreaSeed) {
    this.params = params
    this.path = '/areas'
  }
}

export class PutArea implements APIRequest<Legacy.Area.putAreaResponse> {
  response: Legacy.Area.putAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Legacy.Area.putAreaRequest
  constructor(params: AreaSeed) {
    const areaId = params.id
    this.params = params
    this.path = `/areas/${areaId}`
  }
}

export class DeleteArea implements APIRequest<Legacy.Area.deleteAreaResponse> {
  response: Legacy.Area.deleteAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(areaId: string) {
    this.path = `/areas/${areaId}`
  }
}
